<div class="img-texto">
    <div class="texto-int">Haz click para ubicar tu firma</div>
<img #el [src]="src" *ngIf="src">
</div>